import { render, staticRenderFns } from "./PanelReserveDeadline.vue?vue&type=template&id=1f64e395&scoped=true"
import script from "./PanelReserveDeadline.vue?vue&type=script&lang=js"
export * from "./PanelReserveDeadline.vue?vue&type=script&lang=js"
import style0 from "./PanelReserveDeadline.vue?vue&type=style&index=0&id=1f64e395&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f64e395",
  null
  
)

export default component.exports